// Test id przycisków współdzielonych między widokami RP. Jeden klucz oznacza wspólną funkcję kontrolki. Wyjątek: OPEN_FILTERS_BUTTON występuje w DOM dokładnie raz (patrz niżej).

export const BUTTONS_TEST_ID = {
    // Element otwierający panel filtrów (drawer na desktopie, modal „Filtry” na mobile). Stoi na klikalnym elemencie, nie na ikonie.
    // W gotowym widoku w całym DOM jest dokładnie jeden element z tym id: właścicielem jest aktywny kontekst (zwykły albo przyklejony nagłówek,
    // oferta lub panel oferty nad listingiem na mobile), a pozostałe kopie renderują się bez id. Lokatora nie zawężaj ani nie wybieraj `.first()`.
    OPEN_FILTERS_BUTTON: "filters-open-button"
};
// Test id przycisków współdzielonych między widokami RP. Jeden klucz oznacza wspólną funkcję kontrolki. Wyjątek: OPEN_FILTERS_BUTTON występuje w DOM dokładnie raz (patrz niżej).

export const BUTTONS_TEST_ID = {
    // Element otwierający panel filtrów (drawer na desktopie, modal „Filtry” na mobile). Stoi na klikalnym elemencie, nie na ikonie.
    // W gotowym widoku w całym DOM jest dokładnie jeden element z tym id: właścicielem jest aktywny kontekst (zwykły albo przyklejony nagłówek,
    // oferta lub panel oferty nad listingiem na mobile), a pozostałe kopie renderują się bez id. Lokatora nie zawężaj ani nie wybieraj `.first()`.
    OPEN_FILTERS_BUTTON: "filters-open-button"
};
